<template>
  <a-layout style="min-height: 100vh">
    <a-layout-sider v-model:collapsed="collapsed" collapsible :width="200">
      <h1 style="color: white; padding: 24px;">無老板系统后台</h1>
      <a-menu
        theme="dark"
        mode="inline"
        :open-keys="openKeys"
        :selected-keys="selectedKeys"
        @click="onMenuClicked"
        @openChange="onOpenChanged"
      >
        <side-menu :menus="menus"/>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-content :style="{ height: '100%', margin: '24px 24px 0' }">
        <router-view v-slot="{ Component }">
          <component :is="Component"/>
        </router-view>
      </a-layout-content>
      <a-layout-footer style="text-align: center">
        <global-footer/>
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>

<script>
import { permissionStore } from '@/store/permission';
// layouts/library 组件
import SideMenu from '@/library/SideMenu';
import GlobalFooter from '@/library/GlobalFooter';
import {
  defineComponent,
  ref,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default defineComponent({
  name: 'BasicLayout',
  components: {
    SideMenu,
    GlobalFooter,
  },
  setup() {
    
    const route = useRoute();
    const router = useRouter();
    const selectedKeys = ref([]);
    const openKeys = ref([]);
    
    const onMenuClicked = (e) => {
      router.push({ path: e.key });
    };
    const onOpenChanged = (e) => {
      let keys = e[e.length-1];
      openKeys.value = keys ? [keys] : [];
    };
    const updateMenu = () => {
      // selectedKeys
      const routes = route.matched.concat();
      const { hidden } = route.meta;
      if (routes.length >= 3 && hidden) {
        routes.pop();
        selectedKeys.value = [routes[routes.length - 1].path];
      } else {
        selectedKeys.value = routes.map(e => e.path);
      }
      // openKeys
      const opens = [];
      routes.forEach(item => {
        opens.push(item.path);
      });
      openKeys.value = opens;
    };
    return {
      collapsed: ref(false),
      menus: ref([]),
      selectedKeys,
      openKeys,
      onMenuClicked,
      onOpenChanged,
      updateMenu,
    };
  },
  watch: {
    $route() {
      this.updateMenu();
    }
  },
  created() {
    // 配置 权限验证 路由
    this.menus = permissionStore().addRouters.find(item => item.path === '/').children;
  },
  mounted () {
    this.updateMenu();
    const userAgent = navigator.userAgent;
    if (userAgent.indexOf('Edge') > -1) {
      this.$nextTick(() => {
        this.collapsed = !this.collapsed;
        setTimeout(() => {
          this.collapsed = !this.collapsed;
        }, 16);
      });
    }
  },
});
</script>

<style lang="less">
</style>
